export default {
  showByPeriod({ period }) {
  return axios.post(import.meta.env.VITE_SITE_URL + '/crms/zus-employers/by-period',
    {period},
  );
},
};
